// 操作用户token
// import store from '@/store'
// 定义token存储的key
const TokenKey = 'xktoken'
const UserNameKey = 'xkusername'

// 获取token
export const getToken = () => {
  var token = localStorage.getItem(TokenKey)
  if (!token) {
    token = sessionStorage.getItem(TokenKey)
  }
  return token
}
// 设置token
export const setToken = (token) => {
  localStorage.setItem(TokenKey, token)
  return true
}
// sessionStorage设置token
export const setSessionToken = (token) => {
  sessionStorage.setItem(TokenKey, token)
  return true
}
// 删除token
export const removeToken = () => {
  localStorage.removeItem(TokenKey)
  sessionStorage.removeItem(TokenKey)
  return true
}

// 获取管理员用户名
export const getUserName = () => {
  var username = localStorage.getItem(UserNameKey)
  return username
}
// 设置token
export const setUserName = (username) => {
  localStorage.setItem(UserNameKey, username)
  return true
}
// 删除token
export const removeUserName = () => {
  localStorage.removeItem(UserNameKey)
  return true
}



// WEBPACK FOOTER //
// ./src/utils/auth.js